import { Component, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IMetaData } from "src/app/interfaces";

@Component({
    selector: "circ-metadata-boolean",
    templateUrl: "./boolean.component.html",
    styleUrls: ["./boolean.component.scss"],
    standalone: false
})
export class BooleanComponent {
  @Input()
  @Output()
  public data: IMetaData;

  @Input()
  public formGroup: FormGroup;
}
